import React from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {getAppStoreLink, getPlayStoreLink} from 'utils'
import {IMAGE_ASSET} from 'consts'
import {Image, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 ${convertUnit(20)};
`
const StyledParagraph = styled(Paragraph)`
  text-align: center;
  padding: ${convertUnit(8)};
`
const StyledStoreImagesContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: ${convertUnit(20)};
  gap: ${convertUnit(20)};
`

const StyledImg = styled(Image)`
  height: ${convertUnit(35)};
  width: ${convertUnit(100)};
  object-fit: contain;
`

const StyledLink = styled.a`
  text-decoration: none;
`

export default function GiftShopRobopetRetakeDisabled() {
  const {translate} = useTranslation()
  const googlePlayImg = IMAGE_ASSET('giftshop', 'google-play-icon.png')
  const appStoreImg = IMAGE_ASSET('giftshop', 'app-store-icon.png')
  return (
    <StyledContainer>
      <StyledParagraph fontSize="l" fontWeight="bold">
        {translate('giftShop:retakeKycMobileApp')}
      </StyledParagraph>
      <StyledStoreImagesContainer>
        <StyledLink href={getPlayStoreLink()} target="_blank">
          <StyledImg src={googlePlayImg} alt="google-play" />
        </StyledLink>
        <StyledLink href={getAppStoreLink()} target="_blank">
          <StyledImg src={appStoreImg} alt="app-store" />
        </StyledLink>
      </StyledStoreImagesContainer>
    </StyledContainer>
  )
}
